import ChemiNovaEntityType from "../model/enums/ChemiNovaEntityType";
import AppSections from "./AppSections";

function uiSectionByEntityType(
  entity_type: ChemiNovaEntityType | undefined
): AppSections | undefined {
  switch (entity_type) {
    case ChemiNovaEntityType.SITE:
      return AppSections.SITES;
    case ChemiNovaEntityType.SEARCH:
    case ChemiNovaEntityType.CHELEMENT:
      return AppSections.CHELEMENTS;
    case ChemiNovaEntityType.E3DMODEL:
      return AppSections.E3DS;
    case ChemiNovaEntityType._3DINSTANCE:
      return AppSections._3DINSTANCES;
    case ChemiNovaEntityType.ANNOTATION:
      return AppSections.ANNOTATIONS;
    case ChemiNovaEntityType.COLLECTION:
      return AppSections.COLLECTIONS;
    case ChemiNovaEntityType.MY_LIST:
      return AppSections.MY_LISTS;
  }
  return undefined;
}

export default uiSectionByEntityType;
